import React from "react";
import CompanyLogo from "../../../../core/gd-components/icons/organization/company-logo/organization-logo";
import {CompanyLogoSize} from "../../../../core/gd-components/icons/organization/company-logo/@const";
import {SESSION_COMPANY_PROFILE_CHANGE} from "../../../../core/gd/bus/bus-event-type";

type Props = {
    size?       : CompanyLogoSize
    className?  : string
}

export default class NavigationLogo extends React.Component<Props> {

    constructor(props:Props) {
        super(props);

        gd.bus.subscribe(SESSION_COMPANY_PROFILE_CHANGE,this, this.forceUpdate);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    onClick = () => {
        gd.goTo('select-organization')
    };

    renderGoodDayLogo() {
        return (
            <div className="logo default" onClick={this.onClick}></div>
        )
    }

    renderCompanyLogo() {

        return (
            <div className={Classes("logo",this.props.className)} onClick={this.onClick}>
                <CompanyLogo size={this.props.size} organization={gd.company} />
            </div>
        )
    }

    render() {

        if (gd.session.companies.length <2) {
            return this.renderGoodDayLogo()
        } else {
            return this.renderCompanyLogo()
        }

    }
}
